/**
 * Initialize required plugins for social media sharing.
 */
$(function () {

	// Check to make sure we are on main AR page
	if (document.location.pathname.split('/')[1] == 'viewer') {

		/* FACEBOOK*/
		$.ajaxSetup({ cache: true });
		$.getScript(
			'//connect.facebook.net/en_UK/all.js#xfbml=1&status=0',
			function () {

				FB.init({
					appId: '364279916927160',
					version: lp.apiFacebookVersion || 'v2.9'
				});

				FB.getLoginStatus(function (res) {

					console.log(res);

				});

			},
			function (response) {

				console.log(response);

			}
		);

		/* GOOGLE PLUS*/
		$.getScript('https://apis.google.com/js/platform.js');

	}

});
